import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import EmailVerified from './EmailVerified';
import { useHandleEmailVerification } from '../../../../hooks/useHandleEmailVerification';
import { useHistory } from 'react-router';
import { getSnowplowDuid } from '../../../analytics/Snowplow';

const EmailVerifiedContainer = () => {
	const gigyaUser = useSelector((state) => state.authentication.gigyaUser);
	const history = useHistory();

	useEffect(() => {
		const snowplowDuid = getSnowplowDuid();
		if (
			gigyaUser.data?.snowplow?.domain_sessionid &&
			gigyaUser.data?.snowplow?.domain_sessionid !== snowplowDuid?.domain_sessionid
		) {
			history.replace({
				...location,
				search: `_sp=${gigyaUser.data.snowplow.domain_userid}.${gigyaUser.data.snowplow.time_previous_session}.${gigyaUser.data.snowplow.domain_sessionid}`,
			});
		}
	}, [gigyaUser, gigyaUser?.data?.snowplow, history]);

	return (
		<EmailVerified gigyaUser={gigyaUser} useHandleEmailVerification={useHandleEmailVerification} />
	);
};

export default EmailVerifiedContainer;
